import {
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { DataService } from 'src/app/services/data.service';

import { ModalController } from '@ionic/angular';
import { PosPrintPage } from 'src/app/pages/pos-print/pos-print.page';
import { PrintService } from '../../services/print.service';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
})
export class OrderDetailComponent implements OnInit {
  @Input() items;
  @Input() item_value;

  constructor(public print: PrintService,public db:DataService,private modalCtrl:ModalController) { }

  ngOnInit() {
    // console.log("Items",this.items)
  }
  close(){
    this.modalCtrl.dismiss();
  }

  async printOrder(printList) {
    printList.items = printList.Items
    if(localStorage['print_type'] == 'QZ Tray'){
      this.print.order_id = printList.name;
      this.db.print_emit.next('print emit');
    }
    else{
      let modal = await this.modalCtrl.create({
      component: PosPrintPage, componentProps: {
        bill_details:printList,product_info:printList,is_order:0
      }
    });
    await modal.present();
    }
  //   const modal = await this.modalCtrl.create({
  //   component: PosPrintPage,
  //   cssClass: 'my-custom-class-modaal',
  //   componentProps: {
  //     bill_details:printList,product_info:printList,is_order:0 
  //   }
  // });
  // return await modal.present();
  }
}
